import { createContext } from 'react'

import type { ApolloError } from '@apollo/client'
import type { SettlementCreditTransfer } from '@shared/graphql'

export const STEPS = ['EXPLAINER', 'RESERVE', 'INSTRUCTIONS', 'PROOF'] as const
export type Step = (typeof STEPS)[number]

export type ReserveAmountStepFormValues = {
  amount: number | ''
}

export type UploadProofStepFormValues = {
  evidence: File
  acknowledged: boolean
}

export interface FloatingLimitsState {
  /**
   * Error.
   */
  error?: ApolloError
  /**
   * Loading.
   */
  loading: boolean
  /**
   * Current step.
   */
  currentStep: Step
  /**
   * Settlement credit transfer.
   */
  settlementCreditTransfer?: SettlementCreditTransfer
}

export interface FloatingLimitsActions {
  /**
   * On cancel.
   */
  onCancel: (callback?: () => void) => void
  /**
   * On next step.
   */
  onNextStep: () => void
  /**
   * On start over.
   */
  onStartOver: () => void
  /**
   * On transfer.
   */
  onTransfer: (
    values: ReserveAmountStepFormValues,
    callback?: () => void,
  ) => void
  /**
   * On upload proof.
   */
  onUploadProof: (
    values: UploadProofStepFormValues,
    callback?: () => void,
  ) => void
}

export const DEFAULT_VALUES: FloatingLimitsState = {
  loading: true,
  currentStep: 'EXPLAINER',
}

export const DEFAULT_ACTIONS: FloatingLimitsActions = {
  onCancel: () => null,
  onNextStep: () => null,
  onStartOver: () => null,
  onTransfer: () => null,
  onUploadProof: () => null,
}

export const FloatingLimitsContext = createContext<
  [FloatingLimitsState, FloatingLimitsActions]
>([DEFAULT_VALUES, DEFAULT_ACTIONS])
